import React from 'react';

import type { RouteMatch } from '@confluence/route/entry-points/Route';
import { SpaceRoleManagementScreen } from '@confluence/space-roles/entry-points/SpaceRoleManagementScreen';
import {
	CONTAINER_ADMIN_HOME_ID,
	CONTAINER_HOME_ID,
} from '@confluence/app-navigation/entry-points/navigationIDs';
import {
	SPACE_OVERVIEW,
	ADMIN_COMPANY_HUB_PERMISSIONS,
} from '@confluence/named-routes/entry-points/routes';
import { Redirection } from '@confluence/route-manager/entry-points/Redirection';
import { useSpaceRoleMode } from '@confluence/space-utils/entry-points/useSpaceRoleMode';
import { isCompanyHubSpaceKey } from '@confluence/route-manager/entry-points/companyHubUtils';

export const SpaceMembersRoute = ({ name: routeName, params: { spaceKey } }: RouteMatch) => {
	const { isRbacEnabled, loading } = useSpaceRoleMode();
	const isCompanyHub = isCompanyHubSpaceKey(spaceKey);

	if (isCompanyHub && routeName !== ADMIN_COMPANY_HUB_PERMISSIONS.name) {
		return <Redirection name={ADMIN_COMPANY_HUB_PERMISSIONS.name} params={{ tab: 'users' }} />;
	}

	if (!loading && !isRbacEnabled) {
		return <Redirection name={SPACE_OVERVIEW.name} params={{ spaceKey }} />;
	}

	return <SpaceRoleManagementScreen spaceKey={spaceKey} />;
};

SpaceMembersRoute.NAVIGATION_PARAMS = ({ name, params: { spaceKey } }, isNav4Enabled) => ({
	Screen: {
		screenEvent: { name: 'spaceMembersScreen', id: spaceKey },
		pageState: {
			routeName: name,
			spaceKey,
		},
	},
	MainLayout: {
		navView: isNav4Enabled ? CONTAINER_ADMIN_HOME_ID : CONTAINER_HOME_ID,
		spaceKey,
	},
});
